import React, { useState, useEffect } from 'react';
import styles from './page1.scss';
import { getRem } from '../../func';
import axios from 'axios';
import { Modal } from 'antd';
import 'antd/dist/antd.css';
import { DefaultPlayer as Video } from './Html5Player/index.js';
import './Html5Player/styles.css';

const renderCardList = (data, setQrcodeUrl, setVideoUrl) => {
  return (
    <div
      className={styles['page1-cardList']}
      style={data && data.length > 6 ? { width: getRem(Math.ceil(data.length / 2) * 898) } : {}}
    >
      {
        data.map((item, index) => {
          return (
            <div className={styles['page1-card']} key={index}>
              <div className={styles['page1-card-pic']}>
                <img src={item.cover} />
              </div>

              <div className={styles['page1-card-content']}>
                <div className={styles['page1-card-tags']}>{item.position}</div>

                <div className={styles['page1-card-title']} style={{ fontSize: index === 3 ? getRem(22) : getRem(27) }}>{item.title.toUpperCase()}</div>

                <div className={styles['page1-card-subTitle']}>{item.subTitle.toUpperCase()}</div>

                <div className={styles['page1-card-time']}>{item.time}</div>

                <div className={`${styles['page1-card-desc']} animate1-wrapper`}>
                  <div r='242' g='246' b='247' className={`maskBlock animate1`} style={{ background: 'rgb(242, 246, 247)' }} />
                  {item.desc}
                </div>

                <div className={styles['page1-card-btns']}>
                  {
                    item.btns.map(btn => {
                      return (
                        <div
                          className={styles['page1-card-btn']}
                          key={index + btn.name}
                          onClick={() => {
                            if (btn.type === 'imgList') {
                              window.open(`/#/imgList/${btn.id}`);
                            }

                            if (btn.type === 'link') {
                              window.open(btn.url);
                            }

                            if (btn.type === 'qrcode') {
                              setQrcodeUrl(btn.url);
                            }

                            if (btn.type === 'video') {
                              setVideoUrl(btn.url);
                            }
                          }}
                        >
                          {btn.name}
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          );
        })
      }
    </div>
  );
}

function Page1(props) {
  const [data, setData] = useState(null);
  const [qrcodeUrl, setQrcodeUrl] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    axios.get('https://statics.wow-trend.com/wow-trend-cn/json/activity_list.json').then(res => {
      setData(res.data);
    });
  }, []);

  if (!data) return null;

  return (
    <div
      className={styles['page1']}
      ref={props.myRef}
      style={data && data.length > 6 ? { width: getRem(301 + Math.ceil(data.length / 2) * 898) } : {}}
    >
      <div
        className={styles['page1-main']}
        style={data && data.length > 6 ? { width: getRem(181 + Math.ceil(data.length / 2) * 898) } : {}}
      >
        <div className={styles['page1-title']}>OUR TREND</div>

        <div className={styles['page1-title-subTitle']}>我们的动向</div>

        {renderCardList(data, setQrcodeUrl, setVideoUrl)}
      </div>

      <Modal
        className='my-modal'
        visible={(qrcodeUrl || videoUrl) ? true : false}
        centered
        footer={null}
      >
        {
          videoUrl ?
            <>
              <Video
                muted
                controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen', 'Speed']}
              >
                <source src={videoUrl || ''} />
              </Video>
              <div className='my-close1'>
                <i className='iconfont icontongyongdanchuang-guanbi' onClick={() => setVideoUrl(null)} />
              </div>
            </>
            :
            <>
              <img src={qrcodeUrl} />
              <div className='my-close2'>
                <i className='iconfont icontongyongdanchuang-guanbi' onClick={() => setQrcodeUrl(null)} />
              </div>
            </>
        }
      </Modal>
    </div >
  );
}

export default Page1;